export const plannerViewData = {
    serviceTicketPlanner: {
        header: {
            selector: {
                type:        'connect',
                id:          'ticketId',
                displayField:     'ticketNumber',
                entity:      'serviceTicket',
                listDisplay: { text: '${1} — ${2}', params: ['number', 'title'] },
                placeholder: 'service.planner.header.placeholder',
                modalTitle:  'service.planner.header.modalTitle',
                valueMap:    { ticketId: 'id', ticketNumber: 'number' },
                width:       '300px'
            }
        },
        emptyLabel:            'service.planner.empty',
        shiftHours:            8,
        bufferHours:           8,
        slotMinutes:           5,
        snapMinutes:           5,
        defaultShiftStartHour: 8,
        entities: {
            job:      'serviceTicket',
            task:     'serviceWorkOrder',
            resource: 'serviceTechnician',
        },
        invalidateEntities: ['serviceWorkOrder'],
        fields: {
            capabilityId:    'serviceSkillId',
            capabilityName:  'serviceSkillName',
            resourceId:      'technicianId',
            resourceName:    'technicianName',
            startTime:       'scheduledStart',
            endTime:         'scheduledEnd',
            totalTime:       'estimatedDuration',
            sequence:        'sequence',
            taskLabel:       'title',
            taskSubLabel:    'ticketNumber',
            resourceLabel:   'employeeName',
            resourceSubLabel:'serviceSkillName',
            jobId:           'ticketId',
            statusField:      'status',
            statusNameField:  'statusName',
            statusCollection: 'serviceWorkOrderStatus',
        },
        labels: {
            resourceColumn:      'service.planner.board.technician',
            noResources:         'service.planner.board.noTechnicians',
            unavailable:         'all.unavailable',
            errorSaveTitle:      'service.planner.error.saveFailed.title',
            errorSaveMessage:    'service.planner.error.saveFailed.message',
            errorNoSlotTitle:    'service.planner.error.noSlot.title',
            errorNoSlotMessage:  'service.planner.error.noSlot.message',
            pickNoOps:           'service.planner.pick.noOps',
            pickPending:         'service.planner.pick.pending',
            pickScheduled:       'service.planner.pick.scheduled',
        },
        shiftChain: [
            { direct: true },
            { global: 'serviceSettings', shiftField: 'defaultShiftId' },
        ],
        opInfoModal: {
            title: [
                { key: 'sequence', suffix: '. ' },
                { key: 'title' }
            ],
            fields: [
                { label: 'service.planner.board.technician', key: 'technicianName' },
                { label: 'service.planner.board.skill', key: 'serviceSkillName' },
                { label: 'service.planner.board.customer', key: 'customerName' },
                { label: 'service.planner.board.start', key: 'scheduledStart', format: 'datetime', required: true },
                { label: 'service.planner.board.end', key: 'scheduledEnd', format: 'datetime', required: true },
                { label: 'service.planner.board.duration', key: 'estimatedDuration', format: 'duration', required: true }
            ]
        }
    },
    workOrderPlanner: {
        header: {
            plantSelector: {
                type:        'connect',
                id:          'plantId',
                displayField:     'plantName',
                entity:      'plant',
                placeholder: 'manufacturing.planner.header.plantPlaceholder',
                modalTitle:  'manufacturing.planner.header.plantModalTitle',
                valueMap:    { plantId: 'id', plantName: 'name' },
                width:       '220px'
            },
            selector: {
                type:        'connect',
                id:          'workOrderId',
                displayField:     'workOrderNumber',
                entity:      'workOrder',
                listDisplay: 'number',
                placeholder: 'manufacturing.planner.header.placeholder',
                modalTitle:  'manufacturing.planner.header.modalTitle',
                valueMap:    { workOrderId: 'id', workOrderNumber: 'number' },
                width:       '300px'
            }
        },
        emptyLabel:            'manufacturing.planner.empty',
        shiftHours:            8,
        bufferHours:           8,
        slotMinutes:           5,
        snapMinutes:           5,
        defaultShiftStartHour: 6,
        entities: {
            job:      'workOrder',
            task:     'workOperation',
            resource: 'workCenter',
        },
        invalidateEntities: ['workOperation'],
        fields: {
            capabilityId:    'workCapabilityId',
            capabilityName:  'workCapabilityName',
            resourceId:      'workCenterId',
            resourceName:    'workCenterName',
            resourceCode:    'workCenterCode',
            startTime:       'plannedStart',
            endTime:         'plannedEnd',
            totalTime:       'totalTime',
            sequence:        'sequence',
            taskLabel:       'name',
            taskSubLabel:    'workOrderNumber',
            resourceLabel:   'name',
            resourceSubLabel:'code',
            statusField:      'state',
            statusNameField:  'stateName',
            statusCollection: 'workOperationStatus',
        },
        shiftChain: [
            { refField: 'workDepartmentId', entity: 'workDepartment', shiftField: 'shiftId' },
            { refField: 'plantId',          entity: 'plant',          shiftField: 'shiftId' },
            { global: 'manufacturingSettings', shiftField: 'defaultShiftId' },
        ],
        labels: {
            unavailable: 'all.unavailable',
        },
        opInfoModal: {
            title: [
                { key: 'sequence', suffix: '. ' },
                { key: 'name' }
            ],
            fields: [
                { label: 'manufacturing.planner.board.workCenter',  key: 'workCenterName' },
                { label: 'manufacturing.planner.board.capability',  key: 'workCapabilityName' },
                { label: 'manufacturing.planner.board.product',     key: 'productName' },
                { label: 'manufacturing.planner.board.start',       key: 'plannedStart',  format: 'datetime', required: true },
                { label: 'manufacturing.planner.board.end',         key: 'plannedEnd',    format: 'datetime', required: true },
                { label: 'manufacturing.planner.board.duration',    key: 'totalTime',     format: 'duration', required: true },
                { label: 'manufacturing.planner.board.plannedQty',  key: 'plannedQty' }
            ]
        }
    },

}
